<template>
  <div>
    <documents-add-edit-modal
      v-if="showDocumentsModal"
      v-model="showDocumentsModal"
      :sidebarItems="sidebarItems"
      :selectedSidebarItemIndex="selectedSidebarItemIndex"
      sidebarTitle="Edit Documents"
      :modalTitle="modalTitle"
      :modalSubtitle="modalSubtitle"
      :reloadSelectedDocument="reloadSelectedDocument"
      @onModify="onModify"
      @setCurrentFormItem="setCurrentFormItem"
      :documents="documents"
      @onReload="initData"
    />
  </div>
</template>

<script>
import DocumentsAddEditModal from "../document_archive/DocumentsAddEditModal";
import documentServer from "../../server/document";
import { formatUser } from "../../helpers/user";

export default {
  name: "DocumentMassEditModal",
  components: { DocumentsAddEditModal },
  props: ["documentIds"],
  data() {
    return {
      sidebarItems: null,
      selectedSidebarItemIndex: 0,
      showDocumentsModal: false,
      documents: [],
      reloadSelectedDocument: +new Date()
    };
  },
  async mounted() {
    await this.initData();
  },
  methods: {
    async initData(modifySidebarItems = null) {
      const sidebarItems = [];
      if (modifySidebarItems?.length > 0) {
        this.documentIds = modifySidebarItems.map(x => x.documentId);
      }
      this.documents = await documentServer.documentsFromIdsImproved(
        this.documentIds
      );
      for (let index = 0; index < this.documents.length; index++) {
        const document = this.documents[index];
        sidebarItems.push({
          formId: document.form.id,
          documentId: document.documentId,
          clientId: document.episodeOfCare.patient.id,
          eocId: document.episodeOfCare.id,
          name: document.form.name,
          tooltip: document.form.name,
          documentStatus: document.status,
          documentRefNumber: document.documentRefNumber,
          date: document.createdAt,
          patient: formatUser(document.patient),
          patientData: document.patient,
          mrn: document.episodeOfCare.mrnEocn,
          totalSignature: document.totalSignatures,
          completedSignature: document.completedSignatures,
          style: {
            fontSize: "13px"
          }
        });
      }
      this.sidebarItems = sidebarItems;
      this.showDocumentsModal = true;
    },
    onModify(params) {
      this.$emit("onModify", params);
    },
    async setCurrentFormItem(params) {
      if (this.documents.length == this.sidebarItems.length) {
        this.sidebarItems[this.selectedSidebarItemIndex].documentStatus =
          params.prevDocumentStatus;
      }
      this.selectedSidebarItemIndex =
        params.sidebarItemIndex >= this.sidebarItems.length
          ? 0
          : params.sidebarItemIndex;
      this.reloadSelectedDocument = +new Date();
    }
  },
  computed: {
    modalTitle() {
      let pos = 0;
      if (this.selectedSidebarItemIndex == this.sidebarItems.length) {
        pos = this.sidebarItems.length - 1;
      } else {
        pos = this.selectedSidebarItemIndex;
      }
      if (
        this.sidebarItems[pos].documentRefNumber !=
        this.documents[pos].documentRefNumber
      ) {
        let found = false;
        for (var i = 0; i < this.documents.length && !found; i++) {
          if (
            this.documents[i].documentRefNumber ==
            this.sidebarItems[pos].documentRefNumber
          ) {
            pos = i;
            found = true;
          }
        }
      }

      if (this.documents.length > 0) {
        return `${
          this.documents[pos].documentRefNumber
            ? "Ref# " + this.documents[pos].documentRefNumber + " | "
            : ""
        }${this.documents[pos].form.name}`;
      }
      return "";
    },
    modalSubtitle() {
      let title = "";
      let pos = 0;
      if (this.selectedSidebarItemIndex == this.sidebarItems.length) {
        pos = this.sidebarItems.length - 1;
      } else {
        pos = this.selectedSidebarItemIndex;
      }
      if (
        this.sidebarItems[pos].documentRefNumber !=
        this.documents[pos].documentRefNumber
      ) {
        let found = false;
        for (var i = 0; i < this.documents.length && !found; i++) {
          if (
            this.documents[i].documentRefNumber ==
            this.sidebarItems[pos].documentRefNumber
          ) {
            pos = i;
            found = true;
          }
        }
      } else {
        pos = this.selectedSidebarItemIndex;
      }
      if (this.documents.length > 0) {
        const mrnDescription = this.documents[pos].episodeOfCare.patient.mrn
          ? "Mr# "
          : "";
        title =
          mrnDescription +
          this.formatEoc(
            " | " + this.documents[pos].episodeOfCare.patient.firstName,
            this.documents[pos].episodeOfCare.patient.middleName,
            this.documents[pos].episodeOfCare.patient.preferredName,
            this.documents[pos].episodeOfCare.patient.lastName,
            this.documents[pos].episodeOfCare.patient.mrn,
            this.documents[pos].episodeOfCare.eocn
          );
      }
      return title;
    }
  }
};
</script>

<style scoped>
div >>> .dropdown-menu {
  width: 100%;
}
</style>
